/**
 * GYLT Search Drawer
 * Handles the slide-down search interface
 */
console.log('GYLT Search Drawer Script Loaded');

class GyltSearchDrawer {
    constructor() {
        this.selectors = {
            drawer: '#search-drawer',
            backdrop: '#search-drawer-backdrop',
            panel: '#search-drawer-panel',
            closeBtn: '#search-drawer-close',
            trigger: '.js-search-trigger',
            input: '#search-drawer-input'
        };

        this.drawer = document.querySelector(this.selectors.drawer);
        this.backdrop = document.querySelector(this.selectors.backdrop);
        this.panel = document.querySelector(this.selectors.panel);
        this.input = document.querySelector(this.selectors.input);

        this.isOpen = false;

        this.init();
    }

    init() {
        if (!this.drawer) return;

        // Event Listeners
        document.addEventListener('click', (e) => {
            // Trigger
            if (e.target.closest(this.selectors.trigger)) {
                e.preventDefault();
                this.open();
            }

            // Close Button
            if (e.target.closest(this.selectors.closeBtn)) {
                this.close();
            }

            // Backdrop
            if (e.target === this.backdrop) {
                this.close();
            }
        });

        // Keyboard support
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }

            // Cmd/Ctrl + K shortcut (optional, cool feature)
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                this.isOpen ? this.close() : this.open();
            }
        });
    }

    open() {
        this.isOpen = true;
        this.drawer.classList.remove('invisible');
        document.body.style.overflow = 'hidden';

        // Animate in
        // Use requestAnimationFrame or small timeout to ensure class transition works
        setTimeout(() => {
            if (this.backdrop) this.backdrop.classList.remove('opacity-0');
            if (this.panel) this.panel.classList.remove('-translate-y-full');
        }, 10);

        // Focus input after transition
        setTimeout(() => {
            if (this.input) this.input.focus();
        }, 100);
    }

    close() {
        this.isOpen = false;
        if (this.backdrop) this.backdrop.classList.add('opacity-0');
        if (this.panel) this.panel.classList.add('-translate-y-full');

        // Wait for transition to finish
        setTimeout(() => {
            if (this.drawer) this.drawer.classList.add('invisible');
            document.body.style.overflow = '';
        }, 300);
    }
}

// Initialize
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new GyltSearchDrawer());
} else {
    new GyltSearchDrawer();
}
